import { useEffect } from "react";

/**
 * Sets the document title and (optionally) the meta description for the
 * current public page. Cleans up on unmount so navigating away doesn't
 * leave stale meta tags. Tiny and dependency-free.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let descTag;
    if (description) {
      descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement("meta");
        descTag.setAttribute("name", "description");
        document.head.appendChild(descTag);
      }
      const prevContent = descTag.getAttribute("content");
      descTag.setAttribute("content", description);
      return () => {
        document.title = prevTitle;
        if (descTag && prevContent !== null) {
          descTag.setAttribute("content", prevContent);
        }
      };
    }
    return () => { document.title = prevTitle; };
  }, [title, description]);
}
